import { Component, Type } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Widget } from 'app/views/presentations/widgets/widget';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';

export class UnsupportedWidget extends Widget {
    public type: string = 'Unsupported';
    public icon: string = 'fa-exclamation';
    public nameResourceKey: string = 'modules.editors.unsupported.name';
    public componentType: Type<WidgetComponent> = UnsupportedWidgetComponent;
    public supported: boolean = false;
}

@Component({
    selector: 'psm-unsupported-widget',
    templateUrl: 'unsupported.widget.html'
})
export class UnsupportedWidgetComponent extends WidgetComponent {
    public async updateConfig(configs: any) {
        this.content = configs;
    }

    public async getFormControls(): Promise<AbstractControl[]> {
        return [new FormControl('Unsupported', () => ({ 'modules.editors.unsupported.validation-error': true }))];
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/unsupported/unsupported.widget.ts